exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".tb-cupoms{width:100%;border-collapse:collapse}.tb-cupoms thead th{text-align:left;padding:5px}.tb-cupoms tbody td{padding:5px}.tb-cupoms thead tr{border-bottom:1px solid #999}.tb-cupoms tbody tr{border-bottom:1px solid #ddd}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/src/components/painel/itens/cupons.vue"],"names":[],"mappings":"AACA,WAAW,WAAY,AAAC,wBAA0B,CACjD,AACD,oBAAoB,gBAAgB,WAAY,CAC/C,AACD,oBAAoB,WAAY,CAC/B,AACD,oBAAoB,4BAA6B,CAChD,AACD,oBAAoB,4BAA6B,CAChD","file":"cupons.vue","sourcesContent":["\n.tb-cupoms{width: 100%; border-collapse: collapse;\n}\n.tb-cupoms thead th{text-align:left;padding:5px;\n}\n.tb-cupoms tbody td{padding:5px;\n}\n.tb-cupoms thead tr{border-bottom: 1px solid #999\n}\n.tb-cupoms tbody tr{border-bottom: 1px solid #ddd\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-09b9d684","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/painel/itens/cupons.vue
// module id = 600
// module chunks = 8